import { LEAD_PRODUCT } from '../types';

export const getProductTitle = (product: LEAD_PRODUCT | string) => {
  switch (product) {
    case LEAD_PRODUCT['FEX']: {
      return 'Final Expense';
    }
    case LEAD_PRODUCT['MP']: {
      return 'Mortgage Protection';
    }
    case LEAD_PRODUCT['ANN']: {
      return 'Annuity';
    }
    case 'FS': {
      return 'Financial Seminar';
    }
    default: {
      return product;
    }
  }
};

export const getProductColor = (
  product: LEAD_PRODUCT | string,
): React.CSSProperties['color'] => {
  switch (product) {
    case LEAD_PRODUCT['FEX']: {
      return 'darkgreen';
    }
    case LEAD_PRODUCT['MP']: {
      return 'darkblue';
    }
    case LEAD_PRODUCT['ANN']: {
      return 'darkred';
    }
    case 'FS': {
      return 'steelblue';
    }
    default: {
      return 'inherit';
    }
  }
};
